const PREFIX = '@@KANDY/'

export const REQUEST = PREFIX + 'REQUEST'
export const RESPONSE = PREFIX + 'RESPONSE'

export const AUTHORIZATION_ERROR = PREFIX + 'AUTHORIZATION_ERROR'
